import Modal from 'ud-ui/components/modal';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';

interface RemoveConfirmModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Подтверждение удаления картинки.
 *
 * Спрашиваем, потому что промахнуться по крестику легко, а вернуть картинку
 * нечем: файл выбирают заново, а сохранённое фото после сохранения формы
 * пропадает с бэкенда.
 */
export function RemoveConfirmModal({ isOpen, onCancel, onConfirm }: RemoveConfirmModalProps) {
  return (
    <Modal show={isOpen} onClose={onCancel}>
      <Modal.Body>
        <UDText type="headline" className="mb-2 px-10" style={{ textAlign: 'center' }}>
          Удалить изображение?
        </UDText>
        <UDText type="subhead" style={{ textAlign: 'center' }}>
          После сохранения изображение будет удалено.
        </UDText>
      </Modal.Body>
      <Modal.Footer>
        <UDButton
          className="mb-3 flex w-1/2 items-center justify-center"
          style={{ width: 144 }}
          variant="primary"
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onConfirm();
          }}
        >
          <span>Да</span>
        </UDButton>
        <UDButton
          className="mb-3 flex w-1/2 items-center justify-center"
          style={{ width: 144 }}
          variant="primary"
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            onCancel();
          }}
        >
          <span>Нет</span>
        </UDButton>
      </Modal.Footer>
    </Modal>
  );
}
